var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            title: "激活名单",
            visible: _vm.visibleDialog,
            "before-close": _vm.closeDialog,
            width: "640px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visibleDialog = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { src: require("@/assets/call/icon-warning.png"), alt: "" },
          }),
          _c("h2", [_vm._v("确认将所选的名单激活?")]),
          _c("p", [
            _vm._v("本次选择 "),
            _c("span", { staticStyle: { color: "red" } }, [
              _vm._v(_vm._s(_vm.dataLsit.length)),
            ]),
            _vm._v(" 条已关闭名单，激活后将清空归属人，变为“待分配”状态"),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.closeDialog } },
                [_vm._v("取消")]
              ),
              _vm.dataLsit.length
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        loading: _vm.loading,
                        size: "small",
                        type: "primary",
                      },
                      on: { click: _vm.activateLeads },
                    },
                    [_vm._v("确定激活")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }